import React, { Component, Fragment } from "react";
import { API, Storage } from "aws-amplify";
import config from "../config";

export default class UserProfile extends Component {

    constructor(props){
      super(props);
    }



    getProfilePicElement(){

      const htmlElement =  this.props.userProfile.profilePicUrl && this.props.userProfile.profilePicUrl.length > 0
                             ?  <img src={"" + this.props.userProfile.profilePicUrl} className="img-center profile-pic" />
                             : <div className="profile-picture profile-picture--style-2">
                                 <div className="flex flex-column items-center justify-center br2 ba bw3 b--white shadow-2 pa4 bg-gray2">
                                       <svg aria-hidden="true" data-prefix="fas"
                                           data-icon="user" role="img"
                                           xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                            className="svg-inline--fa fa-user fa-w-14 fa-3x">

                                            <path fill="currentColor"
                                               d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" >
                                            </path>
                                       </svg>
                                 </div>
                             </div>
        return htmlElement;

    }

    switchToProfileView = async event => {
      event.preventDefault();
      this.props.updateView("Profile");
    }

    switchToJobView = async event => {
      event.preventDefault();
      this.props.updateView("Job");
    }

    switchToEducationView = async event => {
      event.preventDefault();
      this.props.updateView("Education");
    }

    switchToPwdChangeView = async event => {
      event.preventDefault();
      this.props.updateView("ChangePassword");
    }

    switchToAreasOfInterest = async event => {
      event.preventDefault();
      this.props.updateView("AreasOfInterest");
    }

   render() {
        if(!this.props.userProfile){
          return(<div></div>);
        }

        var profilePicElement = this.getProfilePicElement();

        return(
          <div className="sidebar sidebar--style-2 no-border stickyfill userprofile">
                  <div className="widget">

                      {profilePicElement}

                      <div className="profile-details">
                          <h2 className="heading heading-4 strong-500 profile-name">{this.props.userProfile.fullName}</h2>
                          <h3 className="heading heading-6 strong-400 profile-occupation mt-3">{this.props.userProfile.currentDesignation}</h3>
                          <h3 className="heading heading-light heading-6 strong-400 profile-location">{this.props.userProfile.currentWorkingCity}</h3>
                      </div>
                      <div className="profile-connect mt-4">
                          <a href="" onClick={this.switchToProfileView} className="btn btn-info btn-styled btn-block btn-rounded ">Update Profile</a>
                          <a href="" onClick={this.switchToPwdChangeView} className="btn btn-info btn-styled  btn-block btn-rounded">Change Password</a>

                          <a href="" onClick={this.switchToJobView} className="btn btn-info btn-styled btn-block btn-rounded">Job Details</a>

                          <a href="" onClick={this.switchToEducationView}  className="btn btn-info btn-styled btn-block btn-rounded ">Education Details</a>
                          <a href="" onClick={this.switchToAreasOfInterest}  className="btn btn-info btn-styled btn-block btn-rounded">Areas Of Interest</a>
                      </div>
                  </div>
          </div>

        );
      }
}



// WEBPACK FOOTER //
// ./src/containers/UserProfile.js